import type { AnyAction } from '@reduxjs/toolkit';
import type { IModuleAction } from './interface';
import actions from './slice';

function Action(dispatcher: (action: AnyAction) => void): IModuleAction {
    return {
        reset: () => {
            dispatcher(actions.reset());
        },
        updateSession: userSession => {
            dispatcher(actions.updateSession({ userSession }));
        },
        updateLanguageId: languageId => {
            dispatcher(actions.updateLanguageId({ languageId }));
        },
        updateTourId: tourId => {
            dispatcher(actions.updateTourId({ tourId }));
        },
        hideProgressBar: () => {
            dispatcher(actions.hideProgressBar());
        },
        showProgressBar: () => {
            dispatcher(actions.showProgressBar());
        },
        setProgress: (progress: number) => {
            dispatcher(actions.setProgress({ progress }));
        },
    };
}

export default Action;
